export const ACCESS_TOKEN = 'accessToken';